<template>
    <div class="flex align-bottom mt-1 gap- group">
        <div class="mx-2 text-center" v-for="number in max" :key="number">
            <label
                class="relative p-0.5 rounded-full flex items-center justify-center cursor-pointer focus:outline-none ring-indigo-500"
            >
                <input
                    type="radio"
                    :name="name"
                    @change="onChange($event)"
                    @click="handleUnsetting(number)"
                    :value="number"
                    class="sr-only"
                    aria-labelledby="color-choice-1-label"
                />
                <div
                    aria-hidden="true"
                    class="h-6 w-6 border border-black border-opacity-10 rounded-full flex items-center justify-center tabular-nums text-xs"
                    :class="{
                        'bg-gray-200': number !== modelValue,
                        'bg-red-400 text-red-800': number === 1 && number === modelValue,
                        'bg-orange-400 text-orange-800': number === 2 && number === modelValue,
                        'bg-yellow-400 text-yellow-800': number === 3 && number === modelValue,
                        'bg-blue-400 text-blue-800': number === 4 && number === modelValue,
                        'bg-green-400 text-green-800': number === 5 && number === modelValue,
                    }"
                >
                    <span class="invisible group-hover:visible">{{ number }}</span>
                </div>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormQuestionLevelDifficultyInput ',
    emits: ['update:modelValue'],
    props: {
        max: {
            required: true,
            type: Number,
        },
        name: {
            required: true,
            type: String,
        },
        modelValue: {
            required: true,
        },
    },
    methods: {
        onChange(event) {
            // this.$emit('update:modelValue', event.target.value);
        },
        handleUnsetting(number) {
            if (number === this.modelValue) {
                this.$emit('update:modelValue', null);
            } else {
                this.$emit('update:modelValue', number);
            }
        },
    },
};
</script>
